import { isPublicNext } from "../../../next/public/mode";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { AuthShell } from "../../base/AuthShell";
import { useTranslation } from "../../../hooks/useTranslation";
import welcomeArt from "../../../assets/images/WelcomeIcon.svg";
import welcomeArtLight from "../../../assets/images/WelcomeIconLight.svg";

// Kept in sync with OnboardingPreview/components/LanguagePicker.tsx and
// SettingsPage/LanguageCard — French is deliberately not offered here yet.
const LANGUAGE_OPTIONS = [
  { value: "en", label: "English" },
  { value: "he", label: "עברית" },
];

export const Layout: FC = () => {
  const { p, t, i18n } = useTranslation("first_page");
  const navigate = useNavigate();

  const pickLanguage = (value: string) => {
    if ((i18n.language || "").split("-")[0] === value) return;
    i18n.changeLanguage(value);
    localStorage.setItem("language", value);
  };

  // Same tile as registration's role choice, so the first two screens of the
  // product read as one design.
  const tiles = [
    {
      key: "register",
      icon: <PersonAddAltRoundedIcon />,
      title: p("welcome_register_title"),
      desc: p("welcome_register_desc"),
      onClick: () => navigate("/registration"),
    },
    {
      key: "login",
      icon: <LoginRoundedIcon />,
      title: p("welcome_login_title"),
      desc: p("welcome_login_desc"),
      onClick: () => navigate("/login"),
    },
  ];

  return (
    <AuthShell
      eyebrow={p("welcome_eyebrow")}
      title={p("welcome_title")}
      subtitle={p("welcome_subtitle")}
      footnote={p("welcome_footnote")}
      art={welcomeArt}
      brandArt={welcomeArtLight}
      entry
      icon="route"
      backTo="/"
      backLabel={p("back_home")}
      footer={isPublicNext() ? undefined : (
        <div
          className="authshell-langpicker"
          role="group"
          aria-label={t("onboarding.role.language")}
        >
          {LANGUAGE_OPTIONS.map((opt) => {
            const selected = (i18n.language || "").split("-")[0] === opt.value;
            return (
              <button
                key={opt.value}
                type="button"
                lang={opt.value}
                className={"authshell-langpicker__opt" + (selected ? " authshell-langpicker__opt--on" : "")}
                aria-pressed={selected}
                onClick={() => pickLanguage(opt.value)}
              >
                {opt.label}
              </button>
            );
          })}
        </div>
      )}
    >
      <div className="authshell-tiles">
        {tiles.map((tile) => (
          <button key={tile.key} type="button" className="authshell-tile" onClick={tile.onClick}>
            <span className="authshell-tile__icon" aria-hidden="true">{tile.icon}</span>
            <span className="authshell-tile__text">
              <span className="authshell-tile__title">{tile.title}</span>
              <span className="authshell-tile__desc">{tile.desc}</span>
            </span>
            <span className="authshell-tile__go" aria-hidden="true"><ChevronRightRoundedIcon /></span>
          </button>
        ))}
      </div>
    </AuthShell>
  );
};
